/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Landing page content displayed when an agent is selected.
 * @export
 * @interface LandingPage
 */
export interface LandingPage {
    /**
     * 
     * @type {string}
     * @memberof LandingPage
     */
    type: LandingPageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LandingPage
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof LandingPage
     */
    tagline: string;
    /**
     * 
     * @type {string}
     * @memberof LandingPage
     */
    content: string;
}


/**
 * @export
 */
export const LandingPageTypeEnum = {
    MarkdownChatCard: 'markdownChatCard'
} as const;
export type LandingPageTypeEnum = typeof LandingPageTypeEnum[keyof typeof LandingPageTypeEnum];


/**
 * Check if a given object implements the LandingPage interface.
 */
export function instanceOfLandingPage(value: object): value is LandingPage {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('tagline' in value) || value['tagline'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function LandingPageFromJSON(json: any): LandingPage {
    return LandingPageFromJSONTyped(json, false);
}

export function LandingPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): LandingPage {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'title': json['title'],
        'tagline': json['tagline'],
        'content': json['content'],
    };
}

export function LandingPageToJSON(json: any): LandingPage {
    return LandingPageToJSONTyped(json, false);
}

export function LandingPageToJSONTyped(value?: LandingPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'title': value['title'],
        'tagline': value['tagline'],
        'content': value['content'],
    };
}

